import React from 'react'
import flag from '../../commonResource/images/icons/16.png'
import FooterLink from './FooterLink';
import $ from "jquery"

function Footer() {
		$(document).on("click", ".footer-links-wrapper h3", function () {
			if ($(window).width() <= 768) {
			$(this).next("ul").slideToggle();
			$(this).toggleClass("expanded");
			console.log("screen width less than 768");
			} else console.log("greater than 768");
		});
		$(window).on("resize", () => {
			window.location.reload(false);
		});
	
    return (<div>
<footer className = "footer-wrapper" >
    <div className = "container" >
        <div className = "upper-text-container" >
            <p> 1. Trade In: Trade‑ in values vary.iPhone 11 and iPhone 11 Pro promotional pricing is after trade‑ in of iPhone 8 Plus and iPhone X in good condition.Additional trade‑ in values require purchase of a new iPhone, subject to availability and limits.Must be at least 18. Apple or its trade - in partners reserve the right to refuse or limit any Trade In transactionfor any reason.In‑ store trade‑ in requires presentation of a valid, government - issued photo ID(local law may require saving this information).Sales tax may be assessed on full value of new iPhone.Additional terms from Apple or Apple’ s trade - in partners may apply.Monthly pricing: Available to qualified customers and requires 0 % APR, 24 - month installment loan with Citizens One or Apple Card Monthly Installments and iPhone activation with AT & T, Sprint, T - Mobile, or Verizon.Taxes and shipping not included.Additional Apple Card Monthly Installments terms are in the <a href = "https://www.goldmansachs.com/terms-and-conditions/Apple-Card-Customer-Agreement.pdf"target = "_blank"> Customer Agreement </a>. Additional iPhone Payments terms are <a href="https:/ / www.apple.com / legal / sales - support / iphoneinstallments_us /"> here</a>.</p> <p> 2. Subscription required. <br/> <br/>Magic Keyboard sold separately. <br/> <br/ >Apple TV + is $4 .99 / month after free trial.One subscription per Family Sharing group.Offer goodfor 3 months after eligible device activation.Plan automatically renews until cancelled.Restrictions and other <a href = "https://www.apple.com/promo/"> terms </a> apply.</p></div> <div className = "footer-links-wrapper row">
                <div className = "links-wrapper-1 col-sm-12 col-md">
                    <h3> Shop and Learn </h3> 
                    <ul>
					<FooterLink linkName ="Mac" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="iPad" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="iPhone" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Watch" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Tv" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Music" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Airpods" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="HomePod" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="ipod touch" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Accessories" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Gift Cards" linkUrl = "https://www.apple.com/"/>
                    </ul>
                    </div> 
                    <div className = "links-wrapper-2 col-sm-12 col-md">
                        <h3> Services </h3> 
                        <ul>
					<FooterLink linkName ="Apple Music" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple News +" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple TV + " linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Arcade" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Card" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="iCloud" linkUrl = "https://www.apple.com/"/>
                            </ul> 
                            <h3> Account </h3> 
                            <ul>
					<FooterLink linkName ="Manage Your Apple ID" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Store Account" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="iCloud.com" linkUrl = "https://www.apple.com/"/>
                                </ul>					
                                </div> 
                                <div className = "links-wrapper-3 col-sm-12 col-md">
                                    <h3> Apple Store </h3>
                                    <ul>
					<FooterLink linkName ="Find a Store" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Genius Bar" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Today at Apple" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Camp" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Field Trip" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Store App" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Refurbished and Clearance" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Financing" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Trade In" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Order Status" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Shopping Help" linkUrl = "https://www.apple.com/"/>
					</ul>
				</div>  
				<div class="links-wrapper-4 col-sm-12 col-md">
					<h3>For Business</h3>
					<ul>
					<FooterLink linkName ="Apple and Business" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Shop for Business" linkUrl = "https://www.apple.com/"/>
					</ul>		
					<h3>For Education</h3>
					<ul>
					<FooterLink linkName ="Apple and Education" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Shop for College" linkUrl = "https://www.apple.com/"/>
					</ul>
					<h3>For Healthcare</h3>
					<ul>
					<FooterLink linkName ="Manage Your Apple ID" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Store Account" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="iCloud.com" linkUrl = "https://www.apple.com/"/>
					</ul>	
					<h3>For Government</h3>
					<ul>
					<FooterLink linkName ="Apple and Education" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Shop for College" linkUrl = "https://www.apple.com/"/>
					</ul>
				</div> 
				<div class="links-wrapper-5 col-sm-12 col-md">
					<h3>Apple Values</h3>
					<ul>
					<FooterLink linkName ="Find a Store" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Genius Bar" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Today at Apple" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Camp" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Field Trip" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Store App" linkUrl = "https://www.apple.com/"/>
					</ul>
					<h3>About Apple</h3>
					<ul>
					<FooterLink linkName ="Find a Store" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Genius Bar" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Today at Apple" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Camp" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Field Trip" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Apple Store App" linkUrl = "https://www.apple.com/"/>
					</ul>						
				</div> 
			</div>
			<div className="my-apple-wrapper"> 
				More ways to shop: <a href="https://www.apple.com/">Find an Apple Store</a> or <a href="https://www.apple.com/">other retailer</a> near you. Or call 1-800-MY-APPLE.
			</div>
			<div className="copyright-wrapper row">
				<div className="copyright col-sm-12 order-2 col-md-8 order-md-1 col-lg-4 order-lg-1">
					Copyright &copy; 2020 Apple Inc. All rights reserved.
				</div>
				<div className="footer-links-terms  col-sm-12 order-3 col-lg-6 order-lg-2">
					<ul>
					<FooterLink linkName ="Privacy Policy" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Terms of Use" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Sales and Refunds" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Legal" linkUrl = "https://www.apple.com/"/>
					<FooterLink linkName ="Site Map" linkUrl = "https://www.apple.com/"/>
					</ul>
				</div>
				<div className="footer-country  col-sm-12 order-1 col-md-4 order-md-2 text-md-right col-lg-2 order-lg-3">
					<div className="flag-wrapper"><img src={flag} alt="United States"/></div> <div className="footer-country-name">United States</div> 
				</div>
			</div>
		</div>
	</footer>
    </div>
    );
}

export default Footer;
